import { useClientReviewsQuery } from "@/gqlhooks/booking/useClientReviewsQuery";
import { getReviewServiceDepartment } from "@/lib/booking-lib";
import { formatDate } from "@/lib/helpers/date";
import { addYears } from "date-fns";
import type { ServiceName } from "@/types/service";
import { GoogleReviews } from "../google-reviews";
import { ReviewCard } from "@/components/shared/review-card/review-card";
import { CustomerReviewWrapper } from "./customer-review-wrapper";
import { useRoute } from "@/components/shared/router";
import { CustomerReviewSkeleton } from "./customer-review-skeleton";

type Props = {
  name: ServiceName;
};

export function CustomerReviews({ name }: Props) {
  const { list, total, averageRating, loading } = useClientReviewsQuery({
    startDate: formatDate(addYears(new Date(), -1)),
    endDate: formatDate(new Date()),
    ...getReviewServiceDepartment(name),
    limit: 5,
  });

  const { push } = useRoute();

  const handleViewAll = () => {
    push({
      pageKey: "customerReviews",
      params: {
        name,
      },
    });
  };

  if (loading) {
    return <CustomerReviewSkeleton />;
  }

  if (list.length === 0) {
    return <GoogleReviews />;
  }

  return (
    <CustomerReviewWrapper
      averageRating={averageRating}
      total={total}
      serviceName={name}
    >
      {list.map((review) => (
        <ReviewCard
          key={review.id}
          onClick={handleViewAll}
          clientName={review.clientName}
          ltv={review.ltv}
          rating={review.rating}
          date={review.date}
          service={review.service}
          description={review.description}
          className="flex h-[180px] flex-col justify-start overflow-hidden border md:h-auto md:border-none"
        />
      ))}
    </CustomerReviewWrapper>
  );
}
